import request from '@/utils/request'

export const communityStatistic = (data = {}) => request({ url: `/api/estate/v1/statistic/communityStatistic`, method: 'post', data })

export const organizationStatistic = (data = {}) => request({ url: `/api/estate/v1/statistic/organizationStat`, method: 'post', data })

export const cityMap = (data = {}) => request({ url: `/api/estate/v1/statistic/cityStatMap`, method: 'post', data })

export const organizationStat = (data = {}) => request({ url: `/api/estate/v1/statistic/organizationStat`, method: 'post', data })

export const communityStat = (data = {}) => request({ url: `/api/estate/v1/statistic/communityStat`, method: 'post', data })
